/**
 * Central runtime configuration, sourced from Vite environment variables.
 * See .env.example for the required values.
 */

const clientId = import.meta.env.VITE_AAD_CLIENT_ID ?? "";
const tenantId = import.meta.env.VITE_AAD_TENANT_ID ?? "common";

export const config = {
  /** Entra ID app registration client id. */
  clientId,
  /**
   * Teams app id used to deep-link to this app's Teams Store listing (the
   * "Buy" entry point for the paidapp-meetingangelo Marketplace offer).
   * Defaults to the AAD client id, matching scripts/package-teams.mjs.
   */
  teamsAppId: import.meta.env.VITE_TEAMS_APP_ID || clientId,
  /** Authority tenant segment: a tenant GUID, "common" or "organizations". */
  tenantId,
  authority: `https://login.microsoftonline.com/${tenantId}`,
  /**
   * Minimal Microsoft Graph delegated permissions this Teams app requests.
   * Keep this list as small as possible for an easy Teams Store review.
   */
  graphScopes: ["User.Read", "Calendars.Read"] as const,
  /** Full Meeting Angelo web app URL used for the hand-off button. */
  mainAppUrl: import.meta.env.VITE_MAIN_APP_URL ?? "https://panel.meetingangelo.com",
  /** Meeting Angelo API base URL used for real meeting reports and SSO login. */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "https://mrai-api.azurewebsites.net/api",
} as const;
